export function InvoiceCreditsCtrl ($state, $scope, $translate, workshopAPI) {
  $scope.showInvoiceCredits = !!$scope.credits.length;

  $scope.tableSettings = {
    columns: [
      {
        field : 'invoice_number',
        header: {
          text: $translate.instant('REPORT_SPACE.FIELD.INVOICE_NUMBER')
        },
      },
      {
        field : 'created_on',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'amount',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_CREDITS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/credit_application_items/invoice_credit_count', $scope.invoice.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'post_date'
    },
  };

  $scope.onRowDoubleClick = function (event) {
    workshopAPI.get('/invoice', [event.row.credit_id]).then(function (invoice) {
      $scope.viewCredit(invoice);
    });
  };

  $scope.getCredits = ( params ) => {
    return workshopAPI.get('/credit_application_items/invoice_credit_list', [
      $scope.invoice.id,
      params.offset,
      params.pageSize,
    ]).then(credits => {
      $scope.credits = credits;

      return credits;
    });
  };

  $scope.viewCredit = function (credit) {
    $state.go('app.invoice', {
      customer_id: credit.customer_id,
      vehicle_id : credit.vehicle_id,
      id         : credit.id
    });
  };
}